/**
 * Parse a number value from a string
 * @param value - The string to parse
 * @returns The number value
 */
export const parseNumber = (value: string): number | null => {
  if (/^\d+$/.test(value)) {
    const numValue = parseInt(value, 10);
    return !isNaN(numValue) ? numValue : null;
  }
  return null;
};
